import BrokenImage from "../../../../components/BrokenImage";
import React, {useEffect, useState} from "react";
import {NavLink, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {t} from "../../../../components/Translate";

const linkStyle = {
    textDecoration: 'none',
    color: 'white',
    width: '100%',
    height: '60px',
};

const MenuItem = withRouter((props) => {
    const [toggler, setToggler] = useState(false);

    const handleNavigate = (path) => (e) => {
        e.preventDefault();
        props.history.push(path);
    };

    useEffect(() => {
        const handleClose = () => setToggler(false);
        window.addEventListener("closeSidebar", handleClose);
        return () => window.removeEventListener("closeSidebar", handleClose);
    }, []);

    const isActive = window.location.pathname === props.path;

    return (
        <React.Fragment>
            <li className={isActive ? 'active-li-nav' : 'li-nav'} key={props.id}>
                <NavLink
                    id={props.id}
                    to={props.path}
                    onClick={handleNavigate(props.path)}
                    style={{ ...linkStyle, position: 'relative' }}
                    className="centered-flex-container sidebar-items"
                >
                    <BrokenImage
                        src={props.imgSrc}
                        alt={props.alt}
                        text={props.name}
                        height="22px"
                        width="22px"
                    />
                    {props.unread > 0 && (
                        <span className="badge">!</span>
                    )}
                    <div className="text-div">
                        <h4 className="text">
                            {t({text: props.name, user: props.user}) || props.name}
                        </h4>
                    </div>
                </NavLink>
            </li>

            {props.children && toggler && props.children}
        </React.Fragment>
    );
});

MenuItem.propTypes = {
    id: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    alt: PropTypes.string,
    imgSrc: PropTypes.string,
    user: PropTypes.object.isRequired,
    children: PropTypes.node,
};

export default MenuItem;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/side-bar/MenuItem.jsx